// The Home (Journal) singleton tab's centre: the workspace's periods told in
// prose (the journal module). Mounts the module (useJournal) and maps the
// view's open requests to the host's existing intents: a resource opens where
// it lives (`openRef`), a conversation opens the chat.

import type { ReactNode } from "react";
import { JournalView, projectJournal } from "../../../modules/journal.js";
import { useAppShell } from "../context.js";
import { useJournal } from "../useJournal.js";

export const HomeCentre = (): ReactNode => {
    const {
        dispatch,
        ports,
        nowMs,
        openConversation,
        openRef,
        summaryConsent,
    } = useAppShell();
    const journal = useJournal(ports);
    return (
        <div style={{ height: "100%", overflowY: "auto" }}>
            <JournalView
                view={projectJournal(journal.model, summaryConsent)}
                send={journal.send}
                nowMs={nowMs}
                summariesOn={summaryConsent}
                // Both Journal Settings links (summaries off; your texts) open
                // the section holding those toggles (G5), not Account.
                onOpenSettings={() =>
                    dispatch({ type: "open-settings", section: "assistant" })
                }
                onOpenResource={openRef}
                onOpenConversation={openConversation}
            />
        </div>
    );
};
